<template>
  <div>
       <b-modal id="modal-help" size="lg" :title="$route.name +'  Help'" ok-only>
   
 

  <div  >
   
<div  >
      
      <div class="panal-header"> {{ info.PageName }}</div>
     <div class="panal-body border">

     <div v-html="info.PageDescription"></div>
    

    <div class="panal" v-for=" help in info.HelpSection" :key="help.SectionName" >
      
      <div class="panal-header2"> {{ help.SectionName }}</div>
     <div class="panal-body">

     <div v-html="help.SectionDescription"></div>
      </div>
     </div>
  </div>
     </div>
  

  </div>
      




  </b-modal>
  </div>

</template>

<script>
import ApplicantService from '../services/Applicant/Applicant.service';
export default {
    props:['id'],
     name:'Help',
data(){
   
    return {
        info : ''
    }
},
beforeMount(){
      //let id = 11;

    ApplicantService.GetHelpPages(this.id).then(response => {
        this.info = response.data
      });
}
}
</script>

<style>
.help {
  color: #fff;
  background-color: #ff8600;
  /* padding: 2px 16px; */
}

.panal {
  background: #fff;
  border-radius: 10px;
  color: #fff;
  padding: 0px 0px 20px 0px;
  margin: 10px 0;
  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
  margin-bottom: 20px !important;
}
.panal-header {
  background: #285475;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}

.panal-header2 {
  background: #346faf;
  color: #ffffff;
  text-align: left;
  border-radius: 10px 0px 0px 0px;
  padding: 10px 20px;
  font-size: 17px;
  font-weight: bold;
  width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body {
  padding: 20px;
  color: #333;
}

</style>